import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
// Components
import SalesOrderViewTable from "./SalesOrderViewTable";
import SalesOrderPaymentTable from "./SalesOrderPaymentTable";
//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import { isLoggedIn } from "../../../components/Cookies/Cookies";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #33993312",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#9f9f9f",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "#33993312",
    padding: "1rem",
    border: "1.5px solid #33993312",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #33993312",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
});

const SalesOrderViewReferenceEncode = () => {
  const { drno, useridNo, branchtype } = useParams();
  const [soInfo, setSoInfo] = useState(null);
  const classes = useStyles();

  const [items, setItems] = useState([]); //data to display in item table
  const [payments, setPayments] = useState([]); //data to display in payment table

  let history = useHistory();

  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  const data = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "so_view_reference", {
        params: {
          sono: drno,
          jc_user_id_no: useridNo,
        },
      })
      .then((res) => {
        setItems(res.data.data.item_info);
        setPayments(res.data.data.payment_info);
        setSoInfo(res.data.data.general_info);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
  const nextpage = {
    pathname: "/package-sales-branchpo",
    soinfo: soInfo,
    iteminfo: items,
    paymentsinfo: payments,
    pageInfo: {
      navname: "Branch Purchase Order Payment",
    },
  };

  const gotopayment = () => {
    history.push({ nextpage });
  };
  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <NavLink to={"/sales"}>
          <h2 style={{ color: "black" }}>Sales</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <NavLink to={"/sales/sales-order-history"}>
          <h2 style={{ color: "black" }}>Sales Order Transaction History</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <h2>Sales Order View Reference #{drno}</h2>
      </div>
      {soInfo ? (
        <div className="page-container">
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                <Grid item xs={12} sm={8}>
                  <div className={classes.subTitle}>
                    Sales Order View Reference
                  </div>
                  <div className={classes.title}>
                    {soInfo.purchase_from || "Sales Order View Reference"}
                  </div>
                </Grid>
                <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
                <Grid item xs={2} className={classes.buttonContainer}></Grid>
              </Grid>
            </div>
            <CardContent>
              <div className={classes.infoContainer}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} className={classes.infoTitle}>
                    Date:
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.infoContent}>
                    {soInfo.date || "Date"}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} className={classes.infoTitle}>
                    Deliver To:
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.infoContent}>
                    {soInfo.deliver_to || "Deliver To"}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} className={classes.infoTitle}>
                    ID No:
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.infoContent}>
                    {soInfo.idno || "ID No"}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} className={classes.infoTitle}>
                    Contact #:
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.infoContent}>
                    {soInfo.contactno || "Contact Number"}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} className={classes.infoTitle}>
                    Classification:
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.infoContent}>
                    {soInfo.classification || "Classification"}
                  </Grid>
                </Grid>
              </div>
              <SalesOrderViewTable items={items} />
              <SalesOrderPaymentTable items={payments} />

              <div className={classes.infoTotal}>
                <div className={classes.infoTotalContent}>
                  <div className={classes.infoTotalItem}>
                    <LocalShippingTwoToneIcon
                      className={classes.infoTotalIcon}
                    />
                    {/* Shipping: 0.00	shipTotal	 */}
                    {"Shipping: " + soInfo.shipping}
                  </div>
                  <div
                    style={{ textAlign: "right" }}
                    className={classes.infoTotalItem}
                  >
                    <ShoppingBasketTwoToneIcon
                      className={classes.infoTotalIcon}
                    />
                    {"Sub-Total: " + numeral(soInfo.subtotal).format("0,0.00")}
                  </div>
                  <div className={classes.infoTotalItem}>
                    <ShoppingCartTwoToneIcon
                      className={classes.infoTotalIcon}
                    />
                    {"Total: " + numeral(soInfo.total).format("0,0.00")}
                  </div>
                </div>
              </div>
              <TextField
                label="Notes"
                multiline
                rows={4}
                variant="outlined"
                value={soInfo.notes || ""}
                className={classes.textarea}
                InputProps={{
                  readOnly: true,
                }}
              />
              <Grid item xs="12">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={gotopayment}
                >
                  Next
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default SalesOrderViewReferenceEncode;
